var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/info_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.16667C3.78 1.16667 1.16667 3.78 1.16667 7C1.16667 10.22 3.78 12.8333 7 12.8333C10.22 12.8333 12.8333 10.22 12.8333 7C12.8333 3.78 10.22 1.16667 7 1.16667ZM6.41667 4.08333V5.25H7.58333V4.08333H6.41667ZM6.41667 6.41667V9.91667H7.58333V6.41667H6.41667ZM2.33333 7C2.33333 9.5725 4.4275 11.6667 7 11.6667C9.5725 11.6667 11.6667 9.5725 11.6667 7C11.6667 4.4275 9.5725 2.33333 7 2.33333C4.4275 2.33333 2.33333 4.4275 2.33333 7Z",
    fill: "#A3A9B9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo14);
export default __webpack_public_path__ + "static/media/info-14.2596af439c2082bdc1e513553f48611e.svg";
export { ForwardRef as ReactComponent };